import { FunctionComponent } from "react";
import classNames from "classnames";

import "./styles.scss";

type Props = {
  color?: "gray";
};

const TopShadow: FunctionComponent<Props> = ({ color }) => {
  return (
    <div
      className={classNames("top-shadow", {
        "top-shadow--gray": color === "gray",
      })}
    />
  );
};

export default TopShadow;
